import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-landing',
  templateUrl: './portfolio-landing.component.html',
  styleUrls: ['./portfolio-landing.component.scss']
})
export class PortfolioLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
